export default __webpack_public_path__ + "static/pic06-0cc03d50b331982c483554802d6dded6.jpg";